import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AppConfiguration } from './app.configuration';

@Injectable(
  {
    providedIn: 'root',
  })
export class Configuration {

  private ApiUrl; // = 'plyca/';
  public plycaJ2EE_CONTEXT; // = 'plycaJ2EE/';
  // No quitar el acceso público, está puesto así los components de las adaptaciones.
  // Hasta que se resuelva como quedará al final este punto debe estar como public
  public ApiVersion; // = 'v1/';
  public UserApiUrl; // = 'userAPI/';
  private AuthApiUrl; // = 'authAPI/';
  private PublicApiUrl; // = 'authAPI/';
  private PlatformApiUrl; // = 'platformAPI/';
  private AdminApiUrl; // = 'adminAPI/';
  public SERVER_URL;
  //  =
  //   environment.host ||
  //   window.location.href.substr(
  //     0,
  //     window.location.href.indexOf('/' + this.ApiUrl) + 1
  //   );
  public PLYCAJ2EE_URL; // = this.SERVER_URL + this.plycaJ2EE_CONTEXT;
  public URL_BASE; // = this.SERVER_URL + this.ApiUrl;
  public ServerWithAuthApiUrl; // =this.URL_BASE + this.AuthApiUrl + this.ApiVersion;
  public ServerWithPublicApiUrl; // =this.URL_BASE + this.AuthApiUrl + this.ApiVersion;
  public ServerWithUserApiUrl; // = this.URL_BASE + this.UserApiUrl + this.ApiVersion;
  public ServerWithPlatformApiUrl; // = this.URL_BASE + this.PlatformApiUrl + this.ApiVersion;
  public autoRefreshToken; // = false;
  public URL_BASE_AFIRMA; // = this.PLYCAJ2EE_URL + 'afirma';

  // URLs de los servicios
  public DOSSIER_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'dossiers/';
  public PROJECTENTITY_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'projects/';
  public DIVISION_SERVICE_URL; // = this.DOSSIER_SERVICE_URL + '{dossierId}/divisions/';
  public PROCUREMENTPROJ_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'procurementProjects/';
  public COMPANYPROJECT_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'companyProjects/';
  public PROCUREMENTPROJLOT_SERVICE_ACTION; // = '/procurementProjectsLots/';
  public PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION; // = this.UserApiUrl + this.ApiVersion + 'procurementProjectsLots/';
  public PROCUREMENTPROJLOTGRP_SERVICE_ACTION; // = '/procurementProjectsLotGroups/';

  public REQUESTEDMATERIAL_SERVICE_URL;
  public TENDER_REQUESTEDMATERIAL_SERVICE_URL;
  public AWARD_REQUESTEDMATERIAL_SERVICE_URL;
  public CONTRACT_REQUESTEDMATERIAL_SERVICE_URL;

  public UNITPRICES_SERVICE_URL;
  public UNITPRICES_LAS_APPROVED_SERVICE_URL;
  // URLs servicio de licencias
  public LICENSE_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'licenses/';
  public LICENSE_PLATFORM_SERVICE_URL; // = this.PlatformApiUrl + this.ApiVersion + 'licenses/';

  public ENVELOPE_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'envelopes/';
  public TENDEREVALCOMMITTEE_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'tenderevaluationcommittees/';
  public TENDERPHASE_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'tenderingphases/';
  public TENDERPHASETYPE_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'tenderingphasetypes/';
  public MASTERDATA_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'masterData/';
  public PROCUREMENTCOMMITTEES_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'procurementCommittees/';

  public AWARD_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'awards/';
  public REQUEST_MATERIAL_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'requestedsMaterials/';

  public RULES_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'rules/';
  public PROCEDURES_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'dossiers/{dossierId}/procedures';
  public HELP_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'help/';
  public HELP_ELEMENT_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'helpElement/';
  public HELPFILES_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'helpFiles/';
  public DOCUMENTS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'documents/';
  public DOCUMENTCLASS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'documentclasses/';
  public DOCUMENTVERSION_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'documents/{docId}/versions/';
  public DOCUMENTFILES_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'documentFiles/';
  public TMPFILES_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'tmpFiles/';
  public TENDER_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'tenders/';
  public TENDER_SUBMISSIONS_SERVICE_URL; // = this.TENDER_SERVICE_URL + 'submissions/';
  public TENDER_SERVICE_V2_URL; // = this.UserApiUrl + 'v2/tenders/';
  public TENDERENVELOPEDOCUMENT_V1_SERVICE_URL; // = this.UserApiUrl + 'v1/tenderenvelopedocuments/';
  public TENDER_ACTION_MIGRATEDOCUMENTS_URL; // = this.UserApiUrl
  // + 'v2/tenders/<tenderId>/actions/createDefaultTenderEnvelopeDocuments?tenderEnvelopeIdentifiers=';

  public ENVELOPEDOCUMENT_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'tenderdocuments/';
  public TENDERLOT_SERVICE_URL; // = this.TENDER_SERVICE_URL + '{tenderIdentifier}/tenderslots/';
  public FAVOURITE_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'favourites/';
  public LASTACCESSED_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'lastaccessed/';
  public USERS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'users/';
  public USERS_ADMIN_SERVICE_URL; // = this.AdminApiUrl + this.ApiVersion + 'users/';
  public FORMULAS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'formulas/';
  public REPORTS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'reports/';
  public PROFILES_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'profiles/';
  public MILESTONES_DOSSIER_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'dossiers/{dossierId}/milestones';
  public MILESTONES_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'milestones/';

  public COMPANY_NAME_URL; // = '/companies/';
  public COMPANY_SERVICE_URL; // = this.UserApiUrl + 'v2' + this.COMPANY_NAME_URL;

  public COMMUNICATIONS_SERVICE_URL; // = this.UserApiUrl + 'v2/communications/';
  public COMMUNICATIONCHANNEL_SERVICE_URL; // = this.COMMUNICATIONS_SERVICE_URL + 'channels/';
  public COMMUNICATIONACTIVITY_URL; // = this.COMMUNICATIONS_SERVICE_URL + 'activities/';
  public EXPENDITURE_PHASE_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'expenditurephases/';
  public DOCUMENT_EVENT_URL; // = this.UserApiUrl + this.ApiVersion + 'documents/{documentIdentifier}/event/stateEvent/{eventId}';
  public INVOICES_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'invoices/';
  public INVOICE_DOCUMENT_EVENT_URL; // = this.UserApiUrl + this.ApiVersion + 'invoices/{documentIdentifier}/event/stateEvent/{eventId}';
  public CONTRACT_MODIFICATIONS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'contractModifications/';
  public REGISTER_CONTRACT_MODIFICATIONS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'registerContractModifications/';
  public CONTRACT_MODIFICATIONS_TYPES_SERVICE_URL; // = this.CONTRACT_MODIFICATIONS_SERVICE_URL + 'activeContractModifications/';
  public REGISTER_CONTRACT_MODIFICATIONS_TYPES_SERVICE_URL;
  // = this.REGISTER_CONTRACT_MODIFICATIONS_SERVICE_URL + 'activeRegisterContractModifications/';
  public CONTRACTS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'contracts/';
  public CUSTOMFIELDS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'customFields/';
  public CUSTOMFIELDGROUPS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'customFieldGroups/';
  public ORGANIZATIONUNIT_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'organizationalUnits/';
  public ADMIN_ORGANIZATIONUNIT_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'organizationalUnits/';
  public UNSTRUCTURED_DOCUMENT_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'unstructuredDocuments/';
  public EXECUTION_PHASE_DOSSIER_SERVICE_URL; // = this.DOSSIER_SERVICE_URL + '{dossierId}/executionDivisions/';
  public EXECUTION_PHASE_CONTRACT_SERVICE_URL; // = this.CONTRACTS_SERVICE_URL + '{contractId}/executionDivisions/';
  public EXPENSE_MANAGEMENTS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'expenseManagements/';
  public ACCOUNTING_DOCUMENT_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'accountingDocuments/';
  public EXPENSE_DOCUMENT_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'expenseDocuments/';
  public IMPORT_EXPENSE_DOCUMENT_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'expenseDocuments/import';
  public LOGIN_EXPENSE_DOCUMENT_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'expenseDocuments/login';
  public ENDORSEMENT_DOCUMENT_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'endorsements/';
  public EXPENSE_DOCUMENT_EVENT_STATEDOCUMENT_URL;
  // = this.UserApiUrl + this.ApiVersion + 'expenseDocuments/{expenseDocumentIdentifier}/event/stateEvent/{eventId}';
  public EXPENSE_DOCUMENT_LINKS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'expensedocumentLinks/';
  public PROCEDURE_ACTION_DOSSIERS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'procedureactiondossiers/';
  public SEARCH_SETTINGS_FILE_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'searchsettingsfiles/';
  public SEARCH_SETTINGS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'searchsettings/';
  public FILEDETAILS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'filedetails/';
  public SIGNATURE_COMMENTS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'tasks/{taskId}/comments';
  public SIGNATURE_COMMENTS_GENERAL_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + '/tasks/comments';
  public DEBTINQUIRIES_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'tasks/{taskId}/debtinquiries';
  public PROPERTY_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'properties/';
  public CRITERIADEF_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'criteriadefinitionmodels/';
  public RESOURCEFILE_SERVICE_URL; // = this.PlatformApiUrl + this.ApiVersion + 'resourcefiles/';
  public HELPDESK_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'helpdesk/options';
  public SUBSTITUTIONS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'substitutions/';
  public SUPPORTSESSIONS_SERVICE_URL;
  public RECEIP_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'receipts/';
  public INBOX_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'inboxes/';
  public USER_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'users/';
  public ADMIN_USER_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'inboxes/';
  public PERSON_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'people/';
  public PROTOCOL_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'protocol/';
  public PROTOCOL_ALLPROFILES; // = this.UserApiUrl + this.ApiVersion + 'protocol/allprofiles';
  public AUDMESSAGE_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'audMessage/';
  public PERSON_ADMIN_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'people/';
  public TAKS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'tasks/';

  public ACTIONDEFINICION_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'actions/';
  public ACTION_EXECUTION_REQUEST_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'actions/requests/';

  public EXPORTPROCESS_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'projectentityexportprocess/';
  public EXPORTPROCESS_CONFIGURATIONS_SERVICE_URL;
  // = this.UserApiUrl + this.ApiVersion + 'projectentityexportprocess/actions/listProcessConfigurations/';
  public TASKASSIGNMENT_URL; // = this.UserApiUrl + this.ApiVersion + 'dossiers/{dossierId}/taskassignments/';
  public LOAD_TASKASSIGNMENT_URL; // = this.TASKASSIGNMENT_URL + 'load/';
  public TENDERCLASSIFICATION_URL; // = this.UserApiUrl + this.ApiVersion + 'dossiers/{dossierId}/tenderClassifications/';
  public LOAD_TENDERCLASSIFICATION_URL; // = this.TENDERCLASSIFICATION_URL + 'load/';

  public PROJECT_ENTITY_USER_AUTHORIZATIONS_URL;
  public CIRCUIT_SERVICE_URL; // = this.UserApiUrl + this.ApiVersion + 'circuits/'
  public PROCEDURECIRCUIT_SERVICE_URL; // = this.UserApiUrl + this.CIRCUIT_SERVICE_URL + 'procedures/'

  public UNITPRICERELATIONDOCUMENT_SERVICE_URL; //

  public ANTECEDENT_SERVICE_URL;


  constructor(public appConfig: AppConfiguration) { }

  public init(): void {
    if (this.appConfig.getValue('plyca_CONTEXT')) {
      this.ApiUrl = this.appConfig.getValue('plyca_CONTEXT');
    } else {
      this.ApiUrl = 'plyca/';
    }
    // parchear la configuracion por si no han puesto la / del final
    if (!this.ApiUrl.endsWith('/')) {
      this.ApiUrl = this.ApiUrl + '/';
    }
    console.log('+++++++++++++', this.appConfig.getValue('plyca_CONTEXT'), this.ApiUrl)
    if (this.appConfig.getValue('plycaJ2EE_CONTEXT')) {
      this.plycaJ2EE_CONTEXT = this.appConfig.getValue('plycaJ2EE_CONTEXT');
    } else {
      this.plycaJ2EE_CONTEXT = 'plycaJ2EE/';
    }
    // parchear la configuracion por si no han puesto la / del final
    if (!this.plycaJ2EE_CONTEXT.endsWith('/')) {
      this.plycaJ2EE_CONTEXT = this.plycaJ2EE_CONTEXT + '/';
    }
    console.log('+++++++++++++', this.appConfig.getValue('plycaJ2EE_CONTEXT'), this.plycaJ2EE_CONTEXT)

    this.ApiVersion = 'v1/';
    this.AuthApiUrl = 'authAPI/';
    this.PublicApiUrl = 'publicAPI/';
    this.UserApiUrl = 'userAPI/';
    this.PlatformApiUrl = 'platformAPI/';
    this.AdminApiUrl = 'adminAPI/';
    this.SERVER_URL =
      environment.host ||
      window.location.href.substr(
        0,
        window.location.href.indexOf('/' + this.ApiUrl) + 1
      );
    this.PLYCAJ2EE_URL = this.SERVER_URL + this.plycaJ2EE_CONTEXT;
    this.URL_BASE = this.SERVER_URL + this.ApiUrl;
    this.ServerWithAuthApiUrl =
      this.URL_BASE + this.AuthApiUrl + this.ApiVersion;
    this.ServerWithPublicApiUrl =
      this.URL_BASE + this.PublicApiUrl + this.ApiVersion;
    this.ServerWithUserApiUrl =
      this.URL_BASE + this.UserApiUrl + this.ApiVersion;
    this.ServerWithPlatformApiUrl =
      this.URL_BASE + this.PlatformApiUrl + this.ApiVersion;
    this.autoRefreshToken = false;
    this.URL_BASE_AFIRMA = this.PLYCAJ2EE_URL + 'afirma';

    // URLs de los servicios
    this.DOSSIER_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'dossiers/';
    this.PROJECTENTITY_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'projects/';
    this.DIVISION_SERVICE_URL =
      this.DOSSIER_SERVICE_URL + '{dossierId}/divisions/';
    this.PROCUREMENTPROJ_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'procurementProjects/';
    this.COMPANYPROJECT_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'companyProjects/';
    this.PROCUREMENTPROJLOT_SERVICE_ACTION = '/procurementProjectsLots/';
    this.PROCUREMENTPROJLOT_ONLY_SERVICE_ACTION =
      this.UserApiUrl + this.ApiVersion + 'procurementProjectsLots/';
    this.PROCUREMENTPROJLOTGRP_SERVICE_ACTION =
      '/procurementProjectsLotGroups/';
    this.REQUESTEDMATERIAL_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'requestedsMaterials/';
    this.TENDER_REQUESTEDMATERIAL_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'TenderRequestedsMaterials/';
    this.AWARD_REQUESTEDMATERIAL_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'AwardRequestedsMaterials/';
    this.CONTRACT_REQUESTEDMATERIAL_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'ContractRequestedsMaterials/';


    this.UNITPRICES_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'unitprice/';
    this.UNITPRICES_LAS_APPROVED_SERVICE_URL = this.UNITPRICES_SERVICE_URL + 'lastapproved/';

    // URLs servicio de licencias
    this.LICENSE_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion +
      'licenses/';
    this.LICENSE_PLATFORM_SERVICE_URL =
      this.PlatformApiUrl + this.ApiVersion +
      'licenses/';

    this.ENVELOPE_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'envelopes/';
    this.TENDEREVALCOMMITTEE_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'tenderevaluationcommittees/';
    this.TENDERPHASE_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'tenderingphases/';
    this.TENDERPHASETYPE_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'tenderingphasetypes/';
    this.MASTERDATA_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'masterData/';
    this.PROCUREMENTCOMMITTEES_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'procurementCommittees/';

    this.AWARD_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'awards/';
    this.REQUEST_MATERIAL_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'requestedsMaterials/';

    this.RULES_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'rules/';
    this.PROCEDURES_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'dossiers/{dossierId}/procedures';
    this.HELP_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'help/';
    this.HELP_ELEMENT_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'helpElement/';
    this.HELPFILES_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'helpFiles/';
    this.DOCUMENTS_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'documents/';
    this.DOCUMENTCLASS_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'documentclasses/';
    this.DOCUMENTVERSION_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'documents/{docId}/versions/';
    this.DOCUMENTFILES_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'documentFiles/';
    this.TMPFILES_SERVICE_URL =
      this.UserApiUrl + this.ApiVersion + 'tmpfiles/';
    this.TENDER_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'tenders/';
    this.TENDER_SUBMISSIONS_SERVICE_URL = this.TENDER_SERVICE_URL + 'submissions/';
    this.TENDER_SERVICE_V2_URL = this.UserApiUrl + 'v2/tenders/';
    this.TENDERENVELOPEDOCUMENT_V1_SERVICE_URL = this.UserApiUrl + 'v1/tenderenvelopedocuments/';
    this.TENDER_ACTION_MIGRATEDOCUMENTS_URL = this.UserApiUrl + 'v2/tenders/<tenderId>/actions/createDefaultTenderEnvelopeDocuments?tenderEnvelopeIdentifiers=';

    this.ENVELOPEDOCUMENT_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'tenderdocuments/';
    this.TENDERLOT_SERVICE_URL = this.TENDER_SERVICE_URL + '{tenderIdentifier}/tenderslots/';
    this.FAVOURITE_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'favourites/';
    this.LASTACCESSED_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'lastaccessed/';
    this.USERS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'users/';
    this.USERS_ADMIN_SERVICE_URL = this.AdminApiUrl + this.ApiVersion + 'users/';
    this.PERSON_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'people/';
    this.AUDMESSAGE_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'audMessage/';
    this.PERSON_ADMIN_SERVICE_URL = this.AdminApiUrl + this.ApiVersion + 'people/';
    this.FORMULAS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'formulas/';
    this.REPORTS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'reports/';
    this.PROFILES_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'profiles/';
    this.MILESTONES_DOSSIER_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'dossiers/{dossierId}/milestones';
    this.MILESTONES_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'milestones/';

    this.COMPANY_NAME_URL = '/companies/';
    this.COMPANY_SERVICE_URL = this.UserApiUrl + 'v2' + this.COMPANY_NAME_URL;

    this.COMMUNICATIONS_SERVICE_URL = this.UserApiUrl + 'v2/communications/';
    this.COMMUNICATIONCHANNEL_SERVICE_URL = this.COMMUNICATIONS_SERVICE_URL + 'channels/';
    this.COMMUNICATIONACTIVITY_URL = this.COMMUNICATIONS_SERVICE_URL + 'activities/';
    this.EXPENDITURE_PHASE_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'expenditurephases/';
    this.INVOICES_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'invoices/';
    this.DOCUMENT_EVENT_URL = this.UserApiUrl + this.ApiVersion + 'documents/{documentIdentifier}/stateEvent/{eventId}';
    this.INVOICE_DOCUMENT_EVENT_URL = this.UserApiUrl + this.ApiVersion + 'invoices/{documentIdentifier}/event/stateEvent/{eventId}';
    this.CONTRACT_MODIFICATIONS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'contractModifications/';
    this.REGISTER_CONTRACT_MODIFICATIONS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'registerContractModifications/';
    this.CONTRACT_MODIFICATIONS_TYPES_SERVICE_URL = this.CONTRACT_MODIFICATIONS_SERVICE_URL + 'activeContractModifications/';
    this.REGISTER_CONTRACT_MODIFICATIONS_TYPES_SERVICE_URL = this.REGISTER_CONTRACT_MODIFICATIONS_SERVICE_URL + 'activeRegisterContractModifications/';
    this.CONTRACTS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'contracts/';
    this.CUSTOMFIELDS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'customFields/';
    this.CUSTOMFIELDGROUPS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'customFieldGroups/';
    this.ORGANIZATIONUNIT_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'organizationalUnits/';
    this.ADMIN_ORGANIZATIONUNIT_SERVICE_URL = this.AdminApiUrl + this.ApiVersion + 'organizationalUnits/';
    this.UNSTRUCTURED_DOCUMENT_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'unstructuredDocuments/';
    this.EXECUTION_PHASE_DOSSIER_SERVICE_URL = this.DOSSIER_SERVICE_URL + '{dossierId}/executionDivisions/';
    this.EXECUTION_PHASE_CONTRACT_SERVICE_URL = this.CONTRACTS_SERVICE_URL + '{contractId}/executionDivisions/';
    this.DEBTINQUIRIES_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'tasks/{taskId}/debtinquires/';
    this.EXPENSE_MANAGEMENTS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'expenseManagements/';
    this.ACCOUNTING_DOCUMENT_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'accountingDocuments/';
    this.IMPORT_EXPENSE_DOCUMENT_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'expenseDocuments/import';
    this.LOGIN_EXPENSE_DOCUMENT_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'expenseDocuments/login';
    this.EXPENSE_DOCUMENT_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'expenseDocuments/';
    this.ENDORSEMENT_DOCUMENT_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'endorsements/';
    this.EXPENSE_DOCUMENT_EVENT_STATEDOCUMENT_URL = this.UserApiUrl + this.ApiVersion + 'expenseDocuments/{expenseDocumentIdentifier}/event/stateEvent/{eventId}';
    this.EXPENSE_DOCUMENT_LINKS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'expensedocumentLinks/';
    this.PROCEDURE_ACTION_DOSSIERS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'procedureactiondossiers/';
    this.SEARCH_SETTINGS_FILE_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'searchsettingsfiles/';
    this.SEARCH_SETTINGS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'searchsettings/';
    this.FILEDETAILS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'filedetails/';
    this.SIGNATURE_COMMENTS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'tasks/{taskId}/comments';
    this.SIGNATURE_COMMENTS_GENERAL_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'tasks/comments';
    this.PROPERTY_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'properties/';
    this.CRITERIADEF_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'criteriadefinitionmodels/';
    this.RESOURCEFILE_SERVICE_URL = this.PlatformApiUrl + this.ApiVersion + 'resourcefiles/';
    this.HELPDESK_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'helpdesk/options';
    this.SUBSTITUTIONS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'substitutions/';
    this.SUPPORTSESSIONS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'supportSessions/';

    this.RECEIP_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'receipts/';
    this.INBOX_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'inboxes/';
    this.USER_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'users/';
    this.ADMIN_USER_SERVICE_URL = this.AdminApiUrl + this.ApiVersion + 'users/';
    this.PROTOCOL_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'protocols/';
    this.PROTOCOL_ALLPROFILES = this.UserApiUrl + this.ApiVersion + 'protocols/allprofiles/';



    this.TAKS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'tasks/';
    this.ACTIONDEFINICION_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'actions/';
    this.ACTION_EXECUTION_REQUEST_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'action/requests/';
    this.CIRCUIT_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'circuits/';
    this.PROCEDURECIRCUIT_SERVICE_URL = this.CIRCUIT_SERVICE_URL + 'procedures/';
    this.EXPORTPROCESS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'projectentityexportprocess/';
    this.EXPORTPROCESS_CONFIGURATIONS_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'projectentityexportprocess/actions/listProcessConfigurations/';

    this.TASKASSIGNMENT_URL = this.UserApiUrl + this.ApiVersion + 'dossiers/{dossierId}/taskassignments/';
    this.TENDERCLASSIFICATION_URL = this.UserApiUrl + this.ApiVersion + 'dossiers/{dossierId}/tenderClassifications/';
    this.LOAD_TASKASSIGNMENT_URL = this.TASKASSIGNMENT_URL + 'load/';
    this.LOAD_TENDERCLASSIFICATION_URL = this.TENDERCLASSIFICATION_URL + 'load/';
    this.PROJECT_ENTITY_USER_AUTHORIZATIONS_URL = this.UserApiUrl + this.ApiVersion + 'projectentityuserauthorizations/';

    this.UNITPRICERELATIONDOCUMENT_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'unitpriceRelationDocuments/';

    this.ANTECEDENT_SERVICE_URL = this.UserApiUrl + this.ApiVersion + 'antecedent/';



  }
}
